import PropTypes from 'prop-types'
import React from 'react'
import { injectIntl } from 'react-intl'
import { SubmissionError } from 'redux-form'
import AddAddressForm from './AddAddressForm'
import mailNameRegex from '../utils/mailNameRegex'
import withLeftSidebar from 'components/Sidebar/withLeftSidebar'

export class AddAddress extends React.Component {
  static propTypes = {
    intl: PropTypes.object.isRequired,
    leftSidebar: PropTypes.object.isRequired,

    incomingMailsDomain: PropTypes.string.isRequired,
    onCreatePublicAddress: PropTypes.func.isRequired,
    boardId: PropTypes.number,
  }

  cancelForm = () => {
    this.props.leftSidebar.pop()
  }

  handleFormSubmit = ({ name, nameType, cardTemplateId, validateAddress }) => {
    const {
      intl,
      onCreatePublicAddress
    } = this.props

    if (nameType === 'custom') {
      if (!name) return

      if (!mailNameRegex.test(name)) {
        throw new SubmissionError({
          name: intl.formatMessage({ id: 'INCOMING_EMAILS_INCORRECT_EMAIL' }),
        })
      }
    }

    return onCreatePublicAddress({
      name: nameType === 'custom' ? name : null,
      cardTemplateId: cardTemplateId === 'empty' ? null : Number(cardTemplateId),
      validateAddress,
    }).then(() => {
      this.cancelForm()
    }).catch(error => {
      if (error.code === 300) {
        throw new SubmissionError({
          name: true,
          cardTemplateId: true,
          _error: intl.formatMessage({ id: 'INCOMING_EMAILS_DUPLICATE' }),
        })
      } else {
        throw error
      }
    })
  }

  render () {
    const {
      incomingMailsDomain,
      boardId,
    } = this.props

    return (
      <AddAddressForm
        incomingMailsDomain={incomingMailsDomain}
        boardId={boardId}
        initialValues={{
          name: '',
          nameType: 'generate',
          cardTemplateId: 'empty',
          validateAddress: false
        }}
        onSubmit={this.handleFormSubmit}
        onCancelClick={this.cancelForm}
      />
    )
  }
}

export default injectIntl(withLeftSidebar(AddAddress))
